export default {
  full_menu: 'Menú completo',
  free: 'GRATIS',
};
